import React, { useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { useLocation } from 'react-router-dom';
import {
  IconButton,
  Tooltip,
  Menu,
  MenuProps,
  useTheme,
  useMediaQuery,
  makeStyles,
} from '@material-ui/core';

import { SvgIconComponent } from '@material-ui/icons';

import { iconColor } from 'src/data/colors';
import { MenuItemProps } from './MenuItem';
import { Item } from './MenuItem';

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props: MenuProps) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

const useStyles = makeStyles((theme) => ({
  icon: {
    color: iconColor,

    [theme.breakpoints.down('sm')]: {
      color: 'white',
    },
  },
}));

interface IndividualMenuProps {
  Icon: SvgIconComponent;
  items: MenuItemProps[];
  title: string;
}

const IndividualMenu: React.FC<IndividualMenuProps> = ({ Icon, items, title }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const location = useLocation();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    handleClose();
  }, [location]);

  return (
    <div>
      <Tooltip title={title}>
        <IconButton
          aria-haspopup="true"
          color="inherit"
          size={isSmallScreen ? 'small' : 'medium'}
          onClick={handleClick}
        >
          <Icon className={classes.icon} />
        </IconButton>
      </Tooltip>
      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {items.map(({ path, name, Icon, onClick, externalPath, addBorder }, index) => (
          <Item
            key={index}
            name={name}
            path={path}
            Icon={Icon}
            onClick={onClick}
            externalPath={externalPath}
            index={index}
            addBorder={addBorder}
          />
        ))}
      </StyledMenu>
    </div>
  );
};

export default IndividualMenu;
